<template>
  <div class="reader-state-buttons">
    <StateButton
      v-for="reader in readers"
      :key="reader.readerId"
      :reader-id="reader.readerId"
      :populated="true"
      :selected="selectedReaders.indexOf(reader.readerId) > -1"
      @click="onClick"
    >
    </StateButton>
    <span class="add-button" @click="onAdd" v-if="showAdd">
      <icon name="plus" />
    </span>
  </div>
</template>

<script>
  import mixins from '../../mixins';
  import { MAX_READER_SELECTIONS } from '../../constants';
  import StateButton from './StateButton.vue';

  export default {
    props: {
      selectedReaders: {
        type: Array,
        default: () => [],
      },
    },
    mixins: [mixins.RouteReaderSelectionsMixin],
    components: { StateButton },
    computed: {
      readers() {
        return this.$store.state.readers;
      },
      showAdd() {
        return this.readers.length < MAX_READER_SELECTIONS;
      },
    },
    methods: {
      onAdd() {
        this.$emit('add');
      },
      onClick(readerId) {
        this.$emit('selected', readerId);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../../variables';
  #app[data-locale="ar"] .reader-state-buttons {
    direction: rtl;
    .add-button {
      margin-left: unset;
      margin-right: 3px;
    }
  }

  .reader-state-buttons {
    display: inline-block;

    .add-button {
      cursor: pointer;
      display: inline-block;
      color: $gray-400;
      margin-left: 3px;
      &:hover {
        color: $gray-800;
      }
      svg {
        width: 20px;
        height: 20px;
        margin-bottom: 1px;
      }
    }
  }
</style>
